import { pdaIndex, pdaZoneCreate, pdaZoneId, pdaZoneEdit, pdaMapRequest } from './pda-routes';
import { settings } from '../settings/settings-routes';
import {RouteRecordRaw} from 'vue-router';

const oldRoutes: RouteRecordRaw[] = [
    { path: '/pdazoneoverview', redirect: pdaIndex },
    { path: '/newpdazone', redirect: pdaZoneCreate },
    { path: '/pdazone/:id', redirect: pdaZoneId },
    { path: '/pdazone_edit/:id', redirect: pdaZoneEdit },
    { path: '/pdamaprequest/:id', redirect: pdaMapRequest },
    { path: '/pdaprofile', redirect: settings },
];

export default oldRoutes;
